import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { IHeaderTitle } from 'app/shared/models/header-title';
import { CompanyService } from 'app/company/services/company.service';
import { SharedService } from 'app/shared/services/shared.service';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';
import { User } from '../../../shared/models/User';

@Component({
    selector: 'app-company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    companies: CompanyListModel[];
    companyList: CompanyListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;
    user: User;
    isAdmin: boolean = false;

    constructor(
        private _router: Router,
        private companyService: CompanyService,
        private fb: FormBuilder,
        private sortService: SortService,
        private router: Router,
        private sharedService: SharedService
    ) {
    }

    ngOnInit() {

        this.headerTitle = { title: 'Companies' }

        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = this.user.isAdmin;
            if (!this.isAdmin) {
                this.router.navigate(['./dashboard']);
            }
        });

        this.companyService.getAll().subscribe(
            companies => {
                this.companies = companies;
                this.companyList = companies;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.companyList = this.sortService.filterAndSortlist(this.companies, newValue, this.lastSort);
        });
    }
}
